import request from '../utils/request'
import qs from 'qs/lib'
// 刷新token
export function refresh_token(params) {
  return request({
    url:  '/index.php/up_login/refresh_token',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 获取首页数据
export function getHomeNumers(params) {
  return request({
    url:  '/index.php/up_order/index',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 获取订单   确认、待回传车架号、已上传车架号、待退回车辆、车辆吸收列表
export function getAllOrderList(params) {
  return request({
    url:  '/index.php/up_order/order_list',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 获取订单详情
export function getOrderDetail(params) {
  return request({
    url:  '/index.php/up_order/order_detail',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 确认门店信息
export function confirm_store(params) {
  return request({
    url:  '/index.php/up_order/confirm_store',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 回传或修改车架号
export function do_vinno(params) {
  return request({
    url:  '/index.php/up_order/do_vinno',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 吸收车辆
export function do_absorb(params) {
  return request({
    url:  '/index.php/up_order/do_absorption',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 退回车辆
export function do_back_logistics(params) {
  return request({
    url:  '/index.php/up_order/do_back_logistics',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 点检操作
export function do_check(params) {
  return request({
    url:  '/index.php/up_order/do_check',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 变更门店
export function do_change(params) {
  return request({
    url:  '/index.php/up_order/do_change',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 查看物流
export function logistics_detail(params) {
  return request({
    url:  '/index.php/up_order/logistics_detail',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 查看订单变更记录
export function order_change_list(params) {
  return request({
    url:  '/index.php/up_order/order_change_list',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 物流公司
export function express_company_list(params) {
  return request({
    url:  '/index.php/up_order/express_company_list',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 导出数据
export function export_order(params) {
  return request({
    url:  '/index.php/up_order/export_order',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 继续吸收
export function do_absorption(params) {
  return request({
    url:  '/index.php/up_order/do_absorption',
    method: 'post',
    data: qs.stringify(params)
  })
}
// 校验车架号是否异常
export function check_vinnos(params) {
  return request({
    url:  '/index.php/up_order/check_vinnos',
    method: 'post',
    data: qs.stringify(params)
  })
}
// SBU 一级 门店 下拉列表
export function sbu_dealer_store(params) {
  return request({
    url:  '/index.php/stores/sbu_dealer_store',
    method: 'post',
    data: qs.stringify(params)
  })
}



// WEBPACK FOOTER //
// ./src/api/port.js